import { ThemeUICSSObject } from '@apia/theme';
import documents from './documents';
import processes from './processes';
import entities from './entities';
import traceability from './traceability';

/* IMPORT HERE */
const monitor: ThemeUICSSObject = {
  processes,
  documents,
  entities,
  traceability,
  /* PREPEND HERE */
};

export default monitor;
